import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  // MenuItem,
  // Select,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import { toast } from "react-toastify";
import { useTheme } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CloseIcon, FilterListIcon } from "../../../../components/Icons";
import { useDispatch, useSelector } from "react-redux";
import { customerDropdown } from "../../../customers/redux/action";
import { scratchEventDropdown } from "../../redux/action";

export default function MyFilter({
  setReqData,
  payLoadData,
  setPayloadData,
  selectFilter,
  setSelectFilter,
  clearFilterdata
}) {
  const { palette, breakpoints } = useTheme();
  const dispatch = useDispatch();
  const isSmall = useMediaQuery(breakpoints.down("sm") || breakpoints.down("xs"));
  const gridSpacing = isSmall ? 2 : 3;
  const [customerOptions, setCustomerOptions] = useState([]);
  const { customerDropdownList } = useSelector((state) => state.customers);
  const [subscriptionOptions, setSubscriptionOptions] = useState([]);
  const { scratchEventDropdownList: subscriptionDropdownList } = useSelector((state) => state.scratchEvent);
  const { user } = useSelector((state) => state.auth);

  // toggel drawer
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  });
  const toggleDrawer = (anchor, open) => (event) => {
    if (event) {
      if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
        return;
      }
    }
    setState({ ...state, [anchor]: open });
  };
  useEffect(() => {
    setCustomerOptions(
      customerDropdownList?.map((item) => {
        return { label: item?.fullName && item?.fullName !== " " ? item?.fullName : item?.phone, value: item?.id };
      })
    );
  }, [customerDropdownList]);

  // const statusOptions = [
  //   { label: "All", value: "" },
  //   { label: "Upcoming", value: "upcoming" },
  //   { label: "Active", value: "active" },
  //   { label: "Expired", value: "expired" }
  // ];

  //dates change handler
  const onChange = (dates) => {
    const [start, end] = dates;
    setPayloadData({ ...payLoadData, activeDateStart: start, activeDateEnd: end });
  };
  // handle change
  // const handleFilterChange = (e) => {
  //   setPayloadData({ ...payLoadData, [e.target.name]: e.target.value });
  // };

  // submit handler
  const submitFilterdata = (e) => {
    if (
      (payLoadData?.activeDateStart !== "" && !payLoadData.activeDateEnd === null) ||
      (payLoadData?.expiryDateStart !== "" && !payLoadData.expiryDateEnd === null)
    ) {
      e.preventDefault();
      toast.error("Please select end date");
    } else {
      e.preventDefault();
      setReqData({
        ...payLoadData,
        activeDateEnd: payLoadData?.activeDateEnd === null ? "" : payLoadData?.activeDateEnd
      });
      let data = selectFilter;

      if (payLoadData.activeDateEnd !== "" && data.indexOf("Activate Date") === -1) {
        data.push("Activate Date");
      }
      if (payLoadData.expiryDateEnd !== "" && data.indexOf("Expire Date") === -1) {
        data.push("Expire Date");
      }
      if (payLoadData.userId !== "" && data.indexOf("Customer") === -1) {
        data.push("Customer");
      }

      if (
        payLoadData.hasOwnProperty("scratchEventId") &&
        payLoadData.scratchEventId !== "" &&
        data.indexOf("Scratch Event") === -1
      ) {
        data.push("Scratch Event");
      }
      setSelectFilter(data);
      setState({ ...state, right: false });
    }
  };

  useEffect(() => {
    dispatch(scratchEventDropdown({ search: "" }));
  }, [dispatch, user]);

  useEffect(() => {
    setSubscriptionOptions(
      subscriptionDropdownList?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  }, [subscriptionDropdownList]);

  const expireOnChange = (dates) => {
    const [start, end] = dates;
    setPayloadData({ ...payLoadData, expiryDateStart: start, expiryDateEnd: end });
  };

  const list = (anchor) => (
    <Box
      id="notificationDrawer"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 400 }}
      role="presentation"
      className="adminDrawer"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" gap="6px" p="16px">
        <Box display="flex" color={palette.primary.main} justifyContent="flex-start" alignItems="center" gap="6px">
          <FilterListIcon />
          <Typography variant="h4" sx={{ fontWeight: "600", color: palette.primary.main }}>
            Filter
          </Typography>
        </Box>
        <IconButton
          onClick={() => {
            setState({ ...state, right: false });
            clearFilterdata("clearall");
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Box p="16px">
        <form autoComplete="off" onSubmit={submitFilterdata}>
          <Grid container spacing={gridSpacing}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <label className="react-select-labels">Activate Date</label>
                <DatePicker
                  className="datePickerStyling-1"
                  showMonthDropdown
                  showYearDropdown
                  selected={payLoadData.activeDateStart}
                  onChange={onChange}
                  startDate={payLoadData.activeDateStart}
                  endDate={payLoadData.activeDateEnd}
                  // maxDate={new Date()}
                  selectsRange
                  placeholderText="Select Date"
                  customInput={
                    <TextField
                      fullWidth
                      size="small"
                      type="text"
                      value={payLoadData.activeDateStart}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                    />
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <label className="react-select-labels">Expire Date</label>
                <DatePicker
                  className="datePickerStyling-1"
                  showMonthDropdown
                  showYearDropdown
                  selected={payLoadData.expiryDateStart}
                  onChange={expireOnChange}
                  startDate={payLoadData.expiryDateStart}
                  endDate={payLoadData.expiryDateEnd}
                  // maxDate={new Date()}
                  selectsRange
                  placeholderText="Select Date"
                  customInput={
                    <TextField
                      fullWidth
                      size="small"
                      type="text"
                      value={payLoadData.expiryDateStart}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                    />
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <label className="react-select-labels">Player</label>
                <Autocomplete
                  disablePortal
                  disableClearable
                  value={customerOptions.filter((x) => x.value === payLoadData.userId)[0]?.label || ""}
                  options={customerOptions}
                  noOptionsText={"Type 3 character..."}
                  filterOptions={(x) => x}
                  onInputChange={(event, value, reason) => {
                    if (reason === "input") {
                      dispatch(customerDropdown({ search: value }));
                    }
                  }}
                  onChange={(event, newValue) => {
                    setPayloadData({ ...payLoadData, userId: newValue?.value });
                  }}
                  name="userId"
                  renderInput={(params) => (
                    <TextField {...params} size="small" placeholder="Search Player and select" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <label className="react-select-labels">Scratch Event</label>
                <Autocomplete
                  disablePortal
                  disableClearable
                  value={subscriptionOptions?.filter((x) => x.value === payLoadData?.scratchEventId)[0]?.label || ""}
                  options={subscriptionOptions}
                  onChange={(event, newValue) => {
                    setPayloadData({ ...payLoadData, scratchEventId: newValue?.value });
                  }}
                  name="scratchEventId"
                  renderInput={(params) => (
                    <TextField {...params} size="small" placeholder="Search scratch event name and select" />
                  )}
                />
              </FormControl>
            </Grid>
            {/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <label className="react-select-labels">Status</label>
                <Select
                  placeholder="Select Status"
                  value={payLoadData.status}
                  onChange={(e) => handleFilterChange(e)}
                  size="small"
                  name="status"
                  displayEmpty
                  className="placestyle"
                >
                  <MenuItem disabled value="">
                    <span>Select Status</span>
                  </MenuItem>
                  {statusOptions?.map((item, i) => {
                    return (
                      <MenuItem key={i} value={item?.value}>
                        {item?.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Button
                variant="outlined"
                sx={{ mr: 1 }}
                onClick={() => {
                  clearFilterdata("clearall");
                  setState({ ...state, right: false });
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                variant="contained"
                onClick={(e) => {
                  submitFilterdata(e);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );

  return (
    <>
      <Button onClick={toggleDrawer("right", true)} color="dark" variant="link">
        {selectFilter.length > 0 ? (
          <Badge
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left"
            }}
            className="notificationBadge"
          >
            <FilterListIcon />
          </Badge>
        ) : (
          <FilterListIcon />
        )}
        Filters
      </Button>
      <Drawer anchor={"right"} open={state["right"]} onClose={toggleDrawer("right", false)}>
        {list("right")}
      </Drawer>
    </>
  );
}
